import { useEffect } from 'react';

export default function TermsModal({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="terms-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="terms-modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="terms-modal-header">
          <h3 id="terms-modal-title" className="terms-modal-title">
            Terms And Conditions
          </h3>
          <button type="button" className="terms-modal-close" onClick={onClose} aria-label="Close terms and conditions">
            x
          </button>
        </div>

        <div className="terms-modal-body">
          <p>
            Thank you for using our services! These terms of service ("Terms") cover your use and access to our
            services, client software, and websites ("Services"). By using our Services, you agree to be bound by
            these Terms and our Privacy Policy. If you are using our Services for an organization, you are agreeing to
            these Terms on behalf of that organization.
          </p>

          <section>
            <h4>Your Information and Your Permissions</h4>
            <p>
              When you use our Services, you provide us with things like your files, content, messages, contacts, and
              so on (your information). Your information is yours. These Terms do not give us any rights to your
              information except for the limited rights that enable us to offer the Services.
            </p>
            <p>
              Our Services also provide you with features like eSign, file sharing, email newsletters, appointment
              setting, and more. These and other features may require our systems to access, store, and scan your
              information. You give us permission to do those things, and this permission extends to our affiliates and
              trusted third parties we work with.
            </p>
          </section>

          <section>
            <h4>Your Responsibilities</h4>
            <p>
              You are responsible for your conduct. Your information and you must comply with applicable laws. Content
              in the Services may be protected by others&apos; intellectual property rights. Please do not copy, upload,
              download, or share content unless you have the right to do so. We may review your conduct and content for
              compliance with these Terms. With that said, we have no obligation to do so. We are not responsible for
              the content people post and share via the Services.
            </p>
            <p>
              Help us keep you informed and your information protected. Safeguard your password to the Services, and
              keep your account information current. Do not share your account credentials or give others access to your
              account.
            </p>
            <p>You may use our Services only as permitted by applicable law, including export control laws and regulations.</p>
          </section>

          <section>
            <h4>Our Information</h4>
            <p>
              The Services are protected by copyright, trademark, and other US and foreign laws. These Terms do not
              grant you any right, title, or interest in the Services, others&apos; content in the Services, ECEA & VR Health, and
              our trademarks, logos, and other brand features. We welcome feedback, but note that we may use comments or
              suggestions without any obligation to you.
            </p>
          </section>

          <section>
            <h4>Copyright</h4>
            <p>
              We respect the intellectual property of others and ask that you do too. We respond to notices of alleged
              copyright infringement if they comply with the law, and such notices should be reported to
              dawn@trivectsolutions.com. We reserve the right to delete or disable content alleged to be infringing and
              terminate accounts of repeat infringers.
            </p>
          </section>

          <section>
            <h4>Termination</h4>
            <p>You are free to stop using our Services at any time. We reserve the right to suspend or terminate your access to the Services with notice to you if:</p>
            <ul>
              <li> you are in breach of these Terms,</li>
              <li> you are using the Services in a manner that would cause a real risk of harm or loss to us or other users.</li>
            </ul>
            <p>
              We will provide you with reasonable advance notice via the email address associated with your account to
              remedy the activity that prompted us to contact you and give you the opportunity to export your
              information from our Services. If after such notice you fail to take the steps we ask of you, we will
              terminate or suspend your access to the Services.
            </p>
            <p>We will not provide notice before termination where:</p>
            <ul>
              <li> you are in material breach of these Terms,</li>
              <li> doing so would cause us legal liability or compromise our ability to provide the Services to our other users, or</li>
              <li> we are prohibited from doing so by law.</li>
            </ul>
          </section>

          <section>
            <h4>Discontinuation of Services</h4>
            <p>
              We may decide to discontinue the Services in response to unforeseen circumstances beyond ECEA & VR Health&apos;s
              control or to comply with a legal requirement. If we do so, we will give you reasonable prior notice so
              that you can export your information from our systems.
            </p>
          </section>

          <section>
            <h4>Services &ldquo;AS IS&rdquo;</h4>
            <p>
              We strive to provide great Services, but there are certain things that we cannot guarantee. TO THE
              FULLEST EXTENT PERMITTED BY LAW, ECEA & VR Health AND ITS AFFILIATES, SUPPLIERS, AND DISTRIBUTORS MAKE NO
              WARRANTIES, EITHER EXPRESS OR IMPLIED, ABOUT THE SERVICES. THE SERVICES ARE PROVIDED &ldquo;AS IS.&rdquo; WE
              ALSO DISCLAIM ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
              Some places do not allow the disclaimers in this paragraph, so they may not apply to you.
            </p>
          </section>

          <section>
            <h4>Limitation of Liability</h4>
            <p>
              WE DO NOT EXCLUDE OR LIMIT OUR LIABILITY TO YOU WHERE IT WOULD BE ILLEGAL TO DO SO-THIS INCLUDES ANY
              LIABILITY FOR ECEA & VR Health OR ITS AFFILIATES&apos; FRAUD OR FRAUDULENT MISREPRESENTATION IN PROVIDING THE
              SERVICES. IN COUNTRIES WHERE THE FOLLOWING TYPES OF EXCLUSIONS ARE NOT ALLOWED, WE ARE RESPONSIBLE TO YOU
              ONLY FOR LOSSES AND DAMAGES THAT ARE A REASONABLY FORESEEABLE RESULT OF OUR FAILURE TO USE REASONABLE CARE
              AND SKILL OR OUR BREACH OF OUR CONTRACT WITH YOU. THIS PARAGRAPH DOES NOT AFFECT CONSUMER RIGHTS THAT
              CANNOT BE WAIVED OR LIMITED BY ANY CONTRACT OR AGREEMENT.
            </p>
            <p>
              IN COUNTRIES WHERE EXCLUSIONS OR LIMITATIONS OF LIABILITY ARE ALLOWED, ECEA & VR Health, ITS AFFILIATES, SUPPLIERS,
              OR DISTRIBUTORS WILL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES, OR ANY LOSS OF USE, DATA, BUSINESS, OR PROFITS, REGARDLESS OF LEGAL THEORY. THESE
              EXCLUSIONS OR LIMITATIONS WILL APPLY REGARDLESS OF WHETHER OR NOT ECEA & VR Health OR ANY OF ITS AFFILIATES HAS
              BEEN WARNED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p>
              IF YOU USE THE SERVICES FOR ANY COMMERCIAL, BUSINESS, OR RE-SALE PURPOSE, ECEA & VR Health, ITS AFFILIATES,
              SUPPLIERS, OR DISTRIBUTORS WILL HAVE NO LIABILITY TO YOU FOR ANY LOSS OF PROFIT, LOSS OF BUSINESS,
              BUSINESS INTERRUPTION, OR LOSS OF BUSINESS OPPORTUNITY. ECEA & VR Health AND ITS AFFILIATES ARE NOT RESPONSIBLE FOR
              THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY USER OF THE SERVICES.
            </p>
          </section>

          <section>
            <h4>Resolving Disputes</h4>
            <p>Let's Try To Sort Things Out First. We want to address your concerns without needing a formal legal case. Before filing a claim against ECEA & VR Health or our affiliates, you agree to try to resolve the dispute informally by contacting dawn@trivectsolutions.com. We will try to resolve the dispute informally by contacting you via email.</p>
            <p>
              Judicial forum for disputes. You and ECEA & VR Health agree that any judicial proceeding to resolve claims relating
              to these Terms or the Services will be brought in the federal or state courts of Texas, subject to the
              mandatory arbitration provisions below. Both you and ECEA & VR Health consent to venue and personal jurisdiction in
              such courts.
            </p>
            <p>
              We Both Agree To Arbitrate. You and ECEA & VR Health agree to resolve any claims relating to these Terms or the
              Services through final and binding arbitration by a single arbitrator. This includes disputes arising out
              of or relating to interpretation or application of this &ldquo;Mandatory Arbitration Provisions&rdquo; section,
              including its enforceability, revocability, or validity.
            </p>
            <p>
              Arbitration Procedures. The American Arbitration Association (AAA) will administer the arbitration under
              its Commercial Arbitration Rules and the Supplementary Procedures for Consumer Related Disputes. The
              arbitration will be held in the United States county where you live or work, Texas, or any other location
              we agree to.
            </p>
            <p>
              NO CLASS ACTIONS. You may only resolve disputes with us on an individual basis and may not bring a claim
              as a plaintiff or a class member in a class, consolidated, or representative action. Class arbitrations,
              class actions, private attorney general actions, and consolidation with other arbitrations are not
              allowed. If this specific paragraph is held unenforceable, then the entirety of this &ldquo;Mandatory
              Arbitration Provisions&rdquo; section will be deemed void.
            </p>
          </section>

          <section>
            <h4>Controlling Law</h4>
            <p>
              These Terms will be governed by California law except for its conflicts of laws principles. However, some
              countries (including those in the European Union) have laws that require agreements to be governed by the
              local laws of the consumer&apos;s country. This paragraph does not override those laws.
            </p>
          </section>

          <section>
            <h4>Entire Agreement</h4>
            <p>
              These Terms constitute the entire agreement between you and ECEA & VR Health with respect to the subject matter of
              these Terms and supersede and replace any other prior or contemporaneous agreements or terms and
              conditions applicable to the subject matter of these Terms. These Terms create no third-party beneficiary
              rights.
            </p>
          </section>

          <section>
            <h4>Revised Waiver, Severability &amp; Assignment Terms</h4>
            <p>
              At ECEA & VR Health, failure to enforce a particular provision does not mean that we waive our right to enforce it
              later. If a provision is deemed unenforceable, the remaining terms of the agreement will continue to
              remain in effect, and we will substitute the unenforceable provision with one that reflects our intentions
              as closely as possible. Please note that you cannot assign any of your rights under these Terms, and any
              attempt to do so will be considered invalid. However, we reserve the right to assign our rights to any
              affiliates, subsidiaries, or any successor in interest of any business associated with the Services.
            </p>
          </section>

          <section>
            <h4>Modifications Terms</h4>
            <p>
              We are committed to providing the best possible services to our users, which may require us to revise
              these Terms from time to time. Such revisions may be made to reflect changes in the law, new regulatory
              requirements, or improvements and enhancements made to our Services. If any modification affects your use
              of the Services or your legal rights, we will notify you before the effective date of the update. We will
              send you an email to the email address associated with your account or send you an in-product
              notification. Please note that the updated terms will take effect no less than 30 days from when we notify
              you.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
